(() => {
  const ROOT_SELECTOR = '[data-hr-product-rush-owned]';
  const INITIALIZED_ATTRIBUTE = 'data-hr-product-rush-initialized';
  const OPTION_SELECTED_CLASSES = {
    '6': 'r-1hbchld',
    '12': 'r-1qbr943',
    '24': 'r-jj9s8e',
  };
  const OPTION_RIDS = {
    '6': 'de8dc4eb-8481-4000-adbe-e7fb7ff1e4a2',
    '12': '4f1b4451-c9ca-4f73-8aa8-cbfaece163ca',
    '24': '4d2fe208-3553-4f91-846a-53d01f4ae7b2',
  };
  const SHOP_NOW_RIDS = [
    '9d4337d7-2127-4a49-8b02-11c35671a1de',
    'e5d00c95-e1a5-4094-bd4a-d65dfafedb9b',
    'ba6d446f-4b2d-47e2-9da6-bdeedee6bc51',
    '447b2937-875e-4181-981e-5a3eb65c83a3',
    '9622cbe1-2b73-4305-aec3-0c73939d4a98',
  ];
  const PRODUCT_LINKS = {
    'e15767f4-0192-476c-89ed-56de163d618a': 'vibe',
    'a5174b4b-50c6-4daa-8d63-7189518be18a': 'orbit',
    'd8533d76-fa9e-4c6d-8d64-a767cd492430': 'citrusVibe',
  };
  const SUBSCRIPTION_RID = '6f377137-233f-4d0d-bda6-285509c4664b';
  const ONE_TIME_RID = 'a0ebf7e0-8ce4-4a75-abef-dee1767bfbfb';
  const PURCHASE_SELECTED_CLASS = 'r-j75apb';
  const ATC_RID = 'abd4c3b3-09f2-4738-9246-d1864af66abf';
  const ATC_LABEL_RID = 'cfa21885-ebaa-48eb-9e83-362221a9a539';
  const SHOP_NOW_TARGET_RID = 'a05538da-cf0d-4038-b089-b164243b623c';
  const ONE_TIME_PRICE_RID = '58ffd1de-762f-4e6e-9873-14bb747209f1';
  const SUBSCRIPTION_UNIT_PRICE_RIDS = [
    '269dee8b-91bb-463c-bf0b-0ffadc9e23eb',
    '79405126-0efb-4c38-8d8a-46a72688f36d',
    'b476f369-2f64-4019-b9a5-a3338732796f',
  ];
  const ONE_TIME_UNIT_PRICE_RIDS = [
    'a4584e37-23f1-4cde-9c98-1a5c3f4b9e22',
    'b5be3dab-8bd0-403a-ad93-22780c79c17b',
    '45e5a914-7966-4c32-8391-fe3f80d72483',
  ];
  const SUBSCRIPTION_UNIT_PRICE_SELECTED_CLASSES = [
    'r-1wh2h8d',
    'r-19o6j1b',
    'r-1hwczjf',
  ];
  const ONE_TIME_UNIT_PRICE_SELECTED_CLASSES = [
    'r-mei08g',
    'r-rn84qw',
    'r-1innxq9',
  ];
  const MOST_POPULAR_BADGE_RID = '43419f7a-3bd8-4113-9a21-9dcf7949f067';
  const BEST_VALUE_BADGE_RID = '3ea98ee2-c279-4ee5-af7f-b0e4d6f145f8';
  const ONE_TIME_RADIO_RING_RID = '29401690-28f0-42b3-a781-b2317c134a3e';
  const ONE_TIME_RADIO_DOT_RID = '3525a887-929d-4c0a-8069-b945e25fe9db';

  const byRid = (root, rid) => root.querySelector(`[data-rid="${rid}"]`);

  const onKeyboardActivate = (element, callback) => {
    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      callback(event);
    });
  };

  const getConfig = (root) => {
    const configElement = root.querySelector('[data-hr-product-rush-config]');
    if (!configElement) return null;

    try {
      return JSON.parse(configElement.textContent);
    } catch (error) {
      console.error('[High Rider Rush] Invalid product configuration.', error);
      return null;
    }
  };

  const formatMoney = (cents, moneyFormat) => {
    const amount = Number(cents || 0) / 100;
    const withCommas = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const withoutTrailingZeros = amount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    const format = moneyFormat || '${{amount}}';

    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(amount).toLocaleString('de-DE'))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withCommas.replace(/,/g, "'"))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, Math.round(amount).toLocaleString('fr-FR'))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withCommas.replace(/,/g, ' '))
      .replace(/\{\{\s*amount_no_trailing_zeros\s*\}\}/g, withoutTrailingZeros);
  };

  const replaceParagraphText = (element, text) => {
    if (!element) return;
    const paragraph = element.querySelector('p');
    if (paragraph) paragraph.textContent = text;
    else element.textContent = text;
  };

  const initializeCarousel = (root, config) => {
    const carousel = root.querySelector('[data-replo-carousel="true"]');
    if (!carousel || !Array.isArray(config.media) || config.media.length === 0) return;

    const mainTrack = carousel.querySelector('[data-replo-part="slide-track"][data-replo-root-id*="R2fmsj2"]');
    const thumbnailTrack = carousel.querySelector('[data-replo-part="slide-track"][data-replo-root-id*="Rnmsj2"]');
    if (!mainTrack || !thumbnailTrack) return;

    const mainTemplate = mainTrack.querySelector('[data-replo-part="slide"]');
    const thumbnailTemplate = thumbnailTrack.querySelector('[data-replo-part="slide"]');
    if (!mainTemplate || !thumbnailTemplate) return;

    const makeSlide = (template, media, index, isThumbnail) => {
      const slide = template.cloneNode(true);
      const image = slide.querySelector('img');
      const picture = slide.querySelector('picture');
      const url = isThumbnail ? media.thumbnailUrl || media.url : media.url;

      slide.id = `hr-product-rush-${isThumbnail ? 'thumbnail' : 'gallery'}-${index + 1}`;
      slide.dataset.slideIndex = String(index);
      slide.dataset.slideSourceIndex = String(index);
      slide.dataset.isActive = index === 0 ? 'true' : 'false';
      slide.dataset.hrRushSlide = String(index);
      slide.removeAttribute('data-is-cloned');
      slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      slide.setAttribute('aria-label', `Slide ${index + 1} of ${config.media.length}`);
      slide.tabIndex = isThumbnail ? 0 : -1;

      if (isThumbnail) {
        slide.setAttribute('role', 'button');
        slide.setAttribute('aria-label', `View product image ${index + 1}`);
        slide.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      }

      if (picture) picture.removeAttribute('id');
      if (image) {
        image.src = url;
        image.alt = media.alt || config.productTitle || 'RUSH product image';
        image.loading = index === 0 && !isThumbnail ? 'eager' : 'lazy';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
      slide.querySelectorAll('source').forEach((source) => source.remove());
      return slide;
    };

    const mainSlides = config.media.map((media, index) => makeSlide(mainTemplate, media, index, false));
    const thumbnailSlides = config.media.map((media, index) => makeSlide(thumbnailTemplate, media, index, true));
    mainTrack.replaceChildren(...mainSlides);
    thumbnailTrack.replaceChildren(...thumbnailSlides);

    const liveRegion = carousel.querySelector('[aria-live="polite"]');
    const previousButton = carousel.querySelector('[data-direction="previous"]');
    const nextButton = carousel.querySelector('[data-direction="next"]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let touchStartX = null;

    const setActive = (nextIndex, shouldFocusThumbnail = false) => {
      activeIndex = (nextIndex + mainSlides.length) % mainSlides.length;
      mainTrack.style.transitionDuration = reducedMotion.matches ? '0ms' : '300ms';
      mainTrack.style.transitionProperty = 'transform';
      mainTrack.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;

      mainSlides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.dataset.isActive = String(isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      thumbnailSlides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.dataset.isActive = String(isActive);
        slide.setAttribute('aria-current', String(isActive));
        slide.querySelector('[data-rid="fb72fd6c-0d38-4953-ae88-b1ab3f7d8b49"]')
          ?.classList.toggle('r-1c289h6', isActive);
        if (isActive && thumbnailTrack.parentElement) {
          thumbnailTrack.parentElement.scrollTo({
            left: slide.offsetLeft,
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
          });
        }
      });
      if (liveRegion) liveRegion.textContent = `Slide ${activeIndex + 1} of ${mainSlides.length}`;
      if (shouldFocusThumbnail) thumbnailSlides[activeIndex].focus({ preventScroll: true });
    };

    thumbnailSlides.forEach((slide, index) => {
      slide.addEventListener('click', () => setActive(index));
      onKeyboardActivate(slide, () => setActive(index));
      slide.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setActive(index - 1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          setActive(index + 1, true);
        }
      });
    });
    previousButton?.addEventListener('click', () => setActive(activeIndex - 1));
    nextButton?.addEventListener('click', () => setActive(activeIndex + 1));
    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
      const distance = touchEndX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 45) return;
      setActive(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    setActive(0);
  };

  const initializeCollapsibles = (root) => {
    root.querySelectorAll('[data-replo-collapsible="true"]').forEach((collapsible) => {
      const trigger = Array.from(collapsible.children).find((child) => child.matches('[role="button"][aria-controls]'));
      if (!trigger) return;
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel || !root.contains(panel)) return;
      const iconPath = trigger.querySelector('svg path')?.getAttribute('d') || '';
      trigger.dataset.hrRushIcon = iconPath.includes('v3h3') || iconPath.includes('v-3h-3') ? 'plus' : 'chevron';

      const setExpanded = (expanded) => {
        collapsible.dataset.state = expanded ? 'open' : 'closed';
        trigger.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
      };
      const toggle = () => setExpanded(trigger.getAttribute('aria-expanded') !== 'true');

      trigger.setAttribute('aria-expanded', 'false');
      setExpanded(collapsible.dataset.state === 'open' && !panel.hidden);
      trigger.addEventListener('click', toggle);
      onKeyboardActivate(trigger, toggle);
    });
  };

  const initializeNavigation = (root, config) => {
    const smoothBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const shopNowTarget = byRid(root, SHOP_NOW_TARGET_RID);

    SHOP_NOW_RIDS.forEach((rid) => {
      const control = byRid(root, rid);
      if (!control || !shopNowTarget) return;
      control.setAttribute('role', control.tagName === 'A' ? 'link' : 'button');
      if (!control.hasAttribute('tabindex')) control.tabIndex = 0;
      control.setAttribute('aria-controls', shopNowTarget.id || 'Shop Now');
      const activate = (event) => {
        event.preventDefault();
        shopNowTarget.scrollIntoView({ behavior: smoothBehavior, block: 'start' });
        window.setTimeout(() => shopNowTarget.focus({ preventScroll: true }), smoothBehavior === 'smooth' ? 500 : 0);
      };
      control.addEventListener('click', activate);
      onKeyboardActivate(control, activate);
    });

    Object.entries(PRODUCT_LINKS).forEach(([rid, routeKey]) => {
      const control = byRid(root, rid);
      const href = config.routes?.[routeKey];
      if (!control || !href) return;
      control.setAttribute('role', 'link');
      if (!control.hasAttribute('tabindex')) control.tabIndex = 0;
      const activate = (event) => {
        event.preventDefault();
        window.location.assign(href);
      };
      control.addEventListener('click', activate);
      onKeyboardActivate(control, activate);
    });
  };

  const initializeReviews = (root) => {
    const badges = root.querySelectorAll('.jdgm-preview-badge');
    if (!badges.length) return;

    badges.forEach((badge) => {
      badge.setAttribute('role', 'link');
      badge.setAttribute('tabindex', '0');
      badge.setAttribute('aria-controls', 'judgeme_product_reviews');
      const activate = (event) => {
        const widget = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
        if (!widget) return;
        event.preventDefault();
        widget.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      };
      badge.addEventListener('click', activate);
      onKeyboardActivate(badge, activate);
    });
  };

  const initializeProductForm = (root, config) => {
    const form = root.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const sellingPlanInput = form?.querySelector('input[name="selling_plan"]');
    const addButton = byRid(root, ATC_RID);
    const buttonLabel = byRid(root, ATC_LABEL_RID);
    const optionList = root.querySelector('[data-replo-option-select="true"]');
    const subscribeControl = byRid(root, SUBSCRIPTION_RID);
    const oneTimeControl = byRid(root, ONE_TIME_RID);
    const planOption = byRid(root, '1d9d463d-e0e7-42e6-8858-b0083f8925b6');
    if (!form || !variantInput || !quantityInput || !sellingPlanInput || !addButton || !optionList) return;

    const variants = Array.isArray(config.variants) ? config.variants : [];
    const defaultVariant = variants.find((variant) => Number(variant.id) === Number(config.defaultVariantId) && variant.available)
      || variants.find((variant) => config.optionValues.includes(String(variant.option1)) && variant.available)
      || variants.find((variant) => variant.available)
      || variants[0];
    let selectedVariant = defaultVariant;
    let purchaseMode = 'subscription';
    let selectedSellingPlanId = Number(config.defaultSellingPlanId);
    let loading = false;

    const optionControls = Object.entries(OPTION_RIDS).map(([value, rid]) => ({
      value,
      element: byRid(root, rid),
    })).filter(({ element }) => element);

    const optionElementByValue = Object.fromEntries(optionControls.map(({ value, element }) => [value, element]));
    const mostPopularBadge = byRid(root, MOST_POPULAR_BADGE_RID);
    const bestValueBadge = byRid(root, BEST_VALUE_BADGE_RID);
    if (mostPopularBadge && optionElementByValue['12']) optionElementByValue['12'].prepend(mostPopularBadge);
    if (bestValueBadge && optionElementByValue['24']) optionElementByValue['24'].prepend(bestValueBadge);

    const availablePlan = (variant) => {
      const plans = Array.isArray(variant?.sellingPlans) ? variant.sellingPlans : [];
      return plans.find((plan) => Number(plan.id) === Number(selectedSellingPlanId)) || plans[0] || null;
    };

    const setButtonLabel = (text) => replaceParagraphText(buttonLabel, text);

    const updatePrices = () => {
      if (!selectedVariant) return;
      const bottleCount = Math.max(1, Number(selectedVariant.option1) || 1);
      const selectedIndex = config.optionValues.indexOf(String(selectedVariant.option1));
      const plan = availablePlan(selectedVariant);
      replaceParagraphText(byRid(root, ONE_TIME_PRICE_RID), formatMoney(selectedVariant.price, config.moneyFormat));

      const oneTimeUnitPrice = `${formatMoney(Math.round(Number(selectedVariant.price) / bottleCount), config.moneyFormat)} ea.`;
      ONE_TIME_UNIT_PRICE_RIDS.forEach((rid, index) => {
        const price = byRid(root, rid);
        if (price) {
          replaceParagraphText(price, oneTimeUnitPrice);
          price.classList.toggle(ONE_TIME_UNIT_PRICE_SELECTED_CLASSES[index], index === selectedIndex);
          price.style.display = index === selectedIndex ? 'flex' : 'none';
        }
      });

      if (plan) {
        const subscriptionUnitPrice = `${formatMoney(Math.round(Number(plan.price) / bottleCount), config.moneyFormat)} ea.`;
        SUBSCRIPTION_UNIT_PRICE_RIDS.forEach((rid, index) => {
          const price = byRid(root, rid);
          if (price) {
            replaceParagraphText(price, subscriptionUnitPrice);
            price.classList.toggle(SUBSCRIPTION_UNIT_PRICE_SELECTED_CLASSES[index], index === selectedIndex);
            price.style.display = index === selectedIndex ? 'flex' : 'none';
          }
        });
        if (planOption) {
          const planText = planOption.querySelector('span') || planOption;
          planText.textContent = formatMoney(plan.price, config.moneyFormat);
          planOption.dataset.sellingPlanId = String(plan.id);
          planOption.setAttribute('aria-selected', 'true');
        }
      }
    };

    const updatePurchaseMode = (mode) => {
      const plan = availablePlan(selectedVariant);
      purchaseMode = mode === 'subscription' && plan ? 'subscription' : 'one-time';
      if (plan) selectedSellingPlanId = Number(plan.id);
      const oneTimeSelected = purchaseMode === 'one-time';

      [
        [subscribeControl, purchaseMode === 'subscription'],
        [oneTimeControl, purchaseMode === 'one-time'],
      ].forEach(([control, isSelected]) => {
        if (!control) return;
        control.setAttribute('role', 'radio');
        control.setAttribute('aria-checked', String(isSelected));
        if (control === subscribeControl) control.classList.toggle(PURCHASE_SELECTED_CLASS, isSelected);
        else control.classList.remove(PURCHASE_SELECTED_CLASS);
        const radio = control.querySelector('input[type="radio"]');
        if (radio) radio.checked = isSelected;
      });
      const oneTimeRing = byRid(root, ONE_TIME_RADIO_RING_RID);
      const oneTimeDot = byRid(root, ONE_TIME_RADIO_DOT_RID);
      oneTimeRing?.style.setProperty('border-color', oneTimeSelected ? '#1b3854' : 'transparent', 'important');
      oneTimeDot?.style.setProperty('background-color', oneTimeSelected ? '#000' : '#fff', 'important');
      oneTimeDot?.style.setProperty('border', oneTimeSelected ? '1px solid #000' : '1px solid rgb(27 56 84 / 50%)', 'important');
      sellingPlanInput.value = purchaseMode === 'subscription' && plan ? String(plan.id) : '';
      updatePrices();
    };

    const updateVariant = (variant) => {
      if (!variant) return;
      selectedVariant = variant;
      variantInput.value = String(variant.id);
      quantityInput.value = '1';

      optionControls.forEach(({ value, element }) => {
        const isSelected = String(variant.option1) === value;
        Object.values(OPTION_SELECTED_CLASSES).forEach((className) => element.classList.remove(className));
        if (isSelected) element.classList.add(OPTION_SELECTED_CLASSES[value]);
        element.setAttribute('aria-selected', String(isSelected));
      });

      const hasPlan = Boolean(availablePlan(variant));
      if (subscribeControl) subscribeControl.setAttribute('aria-disabled', String(!hasPlan));
      const freeShippingRow = byRid(root, '41937bee-8201-4da4-ad29-fa52a694d557');
      if (freeShippingRow) freeShippingRow.hidden = Number(variant.option1) < 12;
      updatePurchaseMode(purchaseMode);
      addButton.disabled = !variant.available;
      addButton.setAttribute('aria-disabled', String(!variant.available));
      setButtonLabel(variant.available ? config.addToCartLabel : config.soldOutLabel);
    };

    const selectOption = (value) => {
      const variant = variants.find((item) => String(item.option1) === String(value));
      if (variant) updateVariant(variant);
    };

    optionControls.forEach(({ value, element }) => {
      element.addEventListener('click', () => selectOption(value));
      onKeyboardActivate(element, () => selectOption(value));
      element.addEventListener('keydown', (event) => {
        const currentIndex = optionControls.findIndex((option) => option.element === element);
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = optionControls[(currentIndex + direction + optionControls.length) % optionControls.length];
        next.element.focus();
        selectOption(next.value);
      });
    });

    const bindPurchaseControl = (control, mode) => {
      if (!control) return;
      control.addEventListener('click', () => updatePurchaseMode(mode));
      onKeyboardActivate(control, () => updatePurchaseMode(mode));
      control.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const nextControl = mode === 'subscription' ? oneTimeControl : subscribeControl;
        nextControl?.focus();
        updatePurchaseMode(mode === 'subscription' ? 'one-time' : 'subscription');
      });
    };
    bindPurchaseControl(subscribeControl, 'subscription');
    bindPurchaseControl(oneTimeControl, 'one-time');

    const setLoading = (isLoading) => {
      loading = isLoading;
      addButton.classList.toggle('hr-product-rush-is-loading', isLoading);
      addButton.disabled = isLoading || !selectedVariant?.available;
      addButton.setAttribute('aria-busy', String(isLoading));
      if (!isLoading) {
        setButtonLabel(selectedVariant?.available ? config.addToCartLabel : config.soldOutLabel);
        return;
      }

      const label = buttonLabel?.querySelector('p') || buttonLabel;
      if (!label) return;
      const computed = window.getComputedStyle(label);
      label.innerHTML = '';
      const loadingText = document.createElement('span');
      const spinner = document.createElement('span');
      loadingText.className = 'hr-product-rush-loading-text';
      loadingText.textContent = 'LOADING';
      loadingText.style.fontFamily = computed.fontFamily;
      loadingText.style.fontSize = computed.fontSize;
      loadingText.style.fontStyle = computed.fontStyle;
      loadingText.style.fontWeight = computed.fontWeight;
      loadingText.style.lineHeight = computed.lineHeight;
      loadingText.style.letterSpacing = computed.letterSpacing;
      loadingText.style.textTransform = computed.textTransform;
      loadingText.style.color = computed.color;
      spinner.className = 'hr-product-rush-loading-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      label.append(loadingText, spinner);
    };

    const openEliteCart = async () => {
      let refreshRequested = false;

      for (let attempt = 0; attempt < 600; attempt += 1) {
        const backdrop = document.getElementById('EliteCartBackdrop');
        const eliteCartDialog = Array.from(document.querySelectorAll('[role="dialog"]'))
          .find((dialog) => dialog.querySelector('.ec-cart-container') || dialog.closest('.ec-cart-container'));
        const backdropStyles = backdrop ? window.getComputedStyle(backdrop) : null;
        const backdropVisible = backdropStyles
          && backdropStyles.display !== 'none'
          && backdropStyles.visibility !== 'hidden';
        const dialogVisible = eliteCartDialog
          && window.getComputedStyle(eliteCartDialog).display !== 'none'
          && window.getComputedStyle(eliteCartDialog).visibility !== 'hidden';

        if (backdropVisible || dialogVisible) return true;

        if (!refreshRequested && typeof window.EliteCart?.openDrawerWithDataRefresh === 'function') {
          refreshRequested = true;
          try {
            await window.EliteCart.openDrawerWithDataRefresh();
          } catch (error) {
            console.warn('[High Rider Rush] EliteCart could not be opened.', error);
          }
        }

        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }

      return false;
    };

    const addToCart = async (event) => {
      event.preventDefault();
      if (loading || !selectedVariant?.available) return;
      const plan = purchaseMode === 'subscription' ? availablePlan(selectedVariant) : null;
      const payload = {
        items: [{
          id: Number(selectedVariant.id),
          quantity: 1,
          ...(plan ? { selling_plan: Number(plan.id) } : {}),
        }],
      };

      setLoading(true);
      try {
        const response = await fetch(`${config.routes?.cartAdd || '/cart/add'}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item to your cart.');

        root.dispatchEvent(new CustomEvent('high-rider:cart-added', {
          bubbles: true,
          detail: { data, product: config.productHandle, variantId: selectedVariant.id, sellingPlanId: plan?.id || null },
        }));
        const eliteCartOpened = await openEliteCart();
        if (!eliteCartOpened) window.location.assign(config.routes?.cart || '/cart');
      } catch (error) {
        console.error('[High Rider Rush] Add to cart failed.', error);
        addButton.dataset.hrProductRushError = error.message || 'Unable to add this item to your cart.';
      } finally {
        setLoading(false);
        if (addButton.dataset.hrProductRushError) {
          setButtonLabel(addButton.dataset.hrProductRushError);
          window.setTimeout(() => {
            delete addButton.dataset.hrProductRushError;
            setButtonLabel(selectedVariant?.available ? config.addToCartLabel : config.soldOutLabel);
          }, 3500);
        }
      }
    };

    form.addEventListener('submit', addToCart);
    addButton.addEventListener('click', addToCart);
    updateVariant(defaultVariant);
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.hasAttribute(INITIALIZED_ATTRIBUTE)) return;
      const config = getConfig(root);
      if (!config) return;
      root.setAttribute(INITIALIZED_ATTRIBUTE, 'true');
      initializeCarousel(root, config);
      initializeCollapsibles(root);
      initializeNavigation(root, config);
      initializeReviews(root);
      initializeProductForm(root, config);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
